import { render, staticRenderFns } from "./embedding-card.vue?vue&type=template&id=03c864b4&scoped=true&"
import script from "./embedding-card.vue?vue&type=script&lang=js&"
export * from "./embedding-card.vue?vue&type=script&lang=js&"
import style0 from "./embedding-card.vue?vue&type=style&index=0&id=03c864b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c864b4",
  null
  
)

export default component.exports